import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import "./index.css";

export function App() {
  return (
    <div className="container mx-auto p-8 text-center relative z-10">
      <Card>
        <CardHeader className="gap-4">
          <CardTitle className="text-3xl font-bold">Samanvaya AI</CardTitle>
          <CardDescription>
            You’re seeing us before the paint has dried! 😔
          </CardDescription>
        </CardHeader>
        <CardContent className="grid gap-4 max-w-[400px]">
          <div>
            We are preparing the prototype for upload.
          </div>
          <div>
            If you are from YC, thank you for visiting. Kindly give us a few hours 🥹
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default App;
